import React from 'react';
import type { AccountPreferences, AccountSettings } from '../../api/accountSettings';
interface PreferenceContext {
  settings: AccountSettings | undefined;
  preferences: AccountPreferences;
  loading: boolean;
  error: Error | null;
  saving: boolean;
  savePreferences: (patch: Partial<AccountPreferences>) => Promise<void>;
  updateProfile: (profile: AccountSettings["profile"]) => void;
  refetch: () => void;
}
export const Context = React.createContext<PreferenceContext | null>(null);
// Optional for existing shell tests and pages mounted outside the main app.
export const useAccountPreferences = () => React.useContext(Context);

